module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_9006.5fb9d567.png";